import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-110">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-111">
        <div className="text-white font-bold text-xl mb-4" data-id="element-112">🔴 ITERA PRO™</div>
        <p className="text-gray-300 font-medium mb-2" data-id="element-113">
          El sistema de gestión de propiedades N°1 para Airbnb Managers en
          Argentina.
        </p>
        <p className="text-sm mb-8 max-w-2xl mx-auto" data-id="element-114">
          Porque gestionar propiedades ajenas y cobrar en dólares no debería
          requerir años de experiencia ni capital propio.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm mb-8" data-id="element-115">
          <a href="mailto:soporteiterapro@gmail.com" className="hover:text-white transition-colors" data-id="element-116">
            📧 soporteiterapro@gmail.com
          </a>
          <span className="hidden md:block text-gray-700" data-id="element-117">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-118">
            🌐 www.iterapro.shop
          </a>
        </div>

        <div className="text-xs text-gray-600 space-y-2" data-id="element-119">
          <p data-id="element-120">© Itera Pro™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-121">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="mt-4 italic" data-id="element-122">
            "El próximo mes puede ser el primero con ingresos en dólares."
          </p>
        </div>
      </div>
    </footer>;
}